<form [formGroup]="vitalsForm" (ngSubmit)="addNewVital()" autocomplete="off">
  <p-float-label class="input-field">
    <p-inputNumber id="heart-rate-float-input" [formControl]="heartRateFormControl"></p-inputNumber>
    <label for="heart-rate-float-input">Heart Rate (bpm)</label>
  </p-float-label>

  <p-float-label class="input-field">
    <p-inputNumber id="oxy-sat-float-input" [formControl]="oxySatFormControl"></p-inputNumber>
    <label for="oxy-sat-float-input">Oxygen Saturation (%)</label>
  </p-float-label>

  <p-float-label class="input-field">
    <p-select id="oxygen-float-input" [options]="oxygenOptions" formControlName="oxygen" [showClear]="true"></p-select>
    <label for="oxygen-float-input">Oxygen</label>
  </p-float-label>

  @if (vitalsForm.get('oxygen')?.value === 'Nasal Cannula') {
  <div>
    <label for="oxygenInput">Liters&nbsp;</label>
    <input type="number" formControlName="oxygenInput" placeholder="Enter Liters" class="p-inputtext" />
  </div>
  }

  <div *ngIf="vitalsForm.get('oxygen')?.value === 'Venturi Mask'">
    <div>
      <label for="oxygenInput">Liters</label>
      <input type="number" formControlName="oxygenInput" placeholder="Enter percentage (%)" class="p-inputtext" />
    </div>
  </div>

  <p-float-label class="input-field">
    <p-inputNumber id="respirations-float-input" [formControl]="respirationsFormControl"></p-inputNumber>
    <label for="respirations-float-input">Respirations</label>
  </p-float-label>

  <p-float-label class="input-field">
    <p-inputNumber [minFractionDigits]="1" id="temperature-float-input"
      [formControl]="temperatureFormControl"></p-inputNumber>
    <label for="temperature-float-input">Temperature (°C)</label>
  </p-float-label>

  <p-float-label class="input-field">
    <p-inputNumber id="systolic-float-input" [formControl]="systolicFormControl"></p-inputNumber>
    <label for="systolic-float-input">Systolic Blood Pressure</label>
  </p-float-label>

  <p-float-label class="input-field">
    <p-inputNumber id="diastolic-float-input" [formControl]="diastolicFormControl"></p-inputNumber>
    <label for="diastolic-float-input">Diastolic Blood Pressure</label>
  </p-float-label>

  <div class="submit-btn-container">
    <button pButton type="submit" [disabled]="!vitalsForm.valid">Add Vital</button>
  </div>
</form>